import { CommonStateEnum } from "./common";
import { Org } from "./org";
import { ProductInfoStateEnum } from "./productInfo";
import { PurchaseOrderItemPrice, Supplier } from "./purchase";
import { User } from "./user";

export interface RootCategory {
  storeType: number
}

export enum ProductDeprecatedEnum {
  UN_DEPRECATED,
  DEPRECATED,
}
export interface Product {
  preReady: number;
  id: string;
  categoryId: string;
  code: string;
  name: string;
  model: string;
  desc: string;
  uom: string;
  category: ProductCategory;
  state: CommonStateEnum;
  cbm?: string;
  process: string;
  docId?: string;
  picDocId?: string;
  t1?: string; // model 2
  hsCode?: string;
  rootCategory?: RootCategory;
  supplier: Supplier;
  deprecated: ProductDeprecatedEnum | null;
  replacementId: string | null;
  replacement: Product | null;
  creator?: User;
  storageRequirements: ProductStoreRequire[];
}

export enum StoreTypeEnum {
  CODE = 1,
  NUM = 2,
}

export interface ProductCategory {
  id: string;
  pId: string;
  path: string;
  code: string;
  name: string;
  desc: string;
  subs: Array<ProductCategory>;
  state: CommonStateEnum;
  storeType: StoreTypeEnum;
  hsCode?: string;
  value?: string;
  orgs: Array<Org>;
}

export interface CategoryAdd {
  pId?: string;
  code: string;
  name: string;
  desc: string;
  hsCode?: string;
}

export interface ProductAdd {
  categoryId?: string;
  code: string;
  name: string;
  model?: string;
  desc?: string;
  uom?: string;
  cbm?: string;
  process: string;
  t1?: string; // model 2
  hsCode?: string;
  replacementId?: string;
  deprecated: ProductInfoStateEnum | null;
}

export interface CategoryUpdate {
  pId?: string;
  code: string;
  name: string;
  desc: string;
}

export interface ProductUpdate {
  categoryId?: string;
  code: string;
  name: string;
  model?: string;
  desc?: string;
  uom?: string;
  cbm?: string;
  process: string;
  t1?: string; // model 2
  hsCode?: string;
}

export interface ProductPrice {
  id: string;
  latest: 1;
  priceId: string;
  supplierId: string;
  productId: string;
  price: string;
  expiredAt: number | null;
  days: number | null; // 到货周期
  mpq: string | null;
  product: Product;
  supplier: Supplier;
  ladders: Array<PurchaseOrderItemPrice>;
  remark: string;
  priceState: 1;
  spareRate: string;
};

export interface InventoryStandard {
  id: string;
  maxStockCount: number;
  minStockCount: number;
  maxStockAgeDays: number;
  minStockAgeDays: number;
  createdAt: number;
  product: Product;
};

export interface AddInventoryStandard {
  productId: string;
  maxStockCount: number;
  minStockCount: number;
  maxStockAgeDays: number;
  minStockAgeDays: number;
};


export enum ProductStoreRequireCodeEnum {
  VACUUM = "VACUUM",
  HIGH_TEMP = "HIGH_TEMP",
  HIGH_HUMIDITY = "HIGH_HUMIDITY",
  OTHER = "OTHER"
};
export interface ProductStoreRequire {
  id: string;
  productId: string;
  storageCode: ProductStoreRequireCodeEnum;
  minValue: number;
  maxValue: number;
  unit: string;
  inspectionCycleDays: number;
  remark: string;
  state: CommonStateEnum;
  createdAt: number;
  updatedAt: number;
};

export interface ProductStoreRequireAdd {
  storageCode: ProductStoreRequireCodeEnum;
  minValue?: number;
  maxValue?: number;
  unit: string;
  inspectionCycleDays?: number;
  remark?: string;
};